import { type Actions, ActionType } from './systems.actions';
import { initialState, type State, systemAdapter } from './systems.state';

export function systemsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }

        case ActionType.FETCH_SYSTEM: {
            return {
                ...state,
                systemsStatuses: {
                    ...state.systemsStatuses,
                    [action.payload.systemId]: {
                        isPending: true,
                        isLoaded: false
                    }
                }
            };
        }

        case ActionType.FETCH_SYSTEM_SUCCEEDED: {
            return {
                ...systemAdapter.addOne(action.payload.system, state),
                systemsStatuses: {
                    ...state.systemsStatuses,
                    [action.payload.system.systemId]: {
                        isPending: false,
                        isLoaded: true
                    }
                }
            };
        }

        case ActionType.FETCH_SYSTEM_FAILED: {
            return {
                ...state,
                systemsStatuses: {
                    ...state.systemsStatuses,
                    [action.payload.systemId]: {
                        isPending: false,
                        isLoaded: false
                    }
                }
            };
        }

        case ActionType.CREATE_SYSTEM: {
            return systemAdapter.addOne(action.payload.system, state);
        }

        case ActionType.UPDATE_SYSTEM: {
            return systemAdapter.updateOne({ id: action.payload.systemId, changes: action.payload.systemUpdate }, state);
        }

        default:
            return state;
    }
}
